// extracted by mini-css-extract-plugin
export var fileUpload = "_ie-1";
export var modalButton = "_ie-0";